module.exports = __webpack_public_path__ + "static/media/141.a34967db.jpg";